import {TransitionService} from '@uirouter/core';
import {AuthenticationService} from './core';

/**
 * This file contains a Transition Hook which protects a
 * route that requires authentication.
 *
 * This hook redirects to /login when both:
 * - The user is not authenticated
 * - The user is navigating to a state that requires authentication
 */
export function requiresAuthHook(transitionService: TransitionService) {
    // Matches if the destination state's data property has a truthy 'requiresAuth' property
    const requiresAuthCriteria = {
        to: (state: any) => state.data && state.data.requiresAuth
    };

    const getServices = (transition: any) => ({
        auth: transition.injector().get(AuthenticationService) as AuthenticationService,
        $state: transition.router.stateService,
    });

    const goToHomeOrLogin = (auth: AuthenticationService, $state: any) => {
        const selectedModuleHash = localStorage.getItem('selectedModuleHash');
        return auth.isAuthenticated()
            ? $state.target('home', { selectedModuleHash }, { location: true })
            : $state.target('login', undefined, { location: true });
    };

    const redirectToLogin = (transition: any) => {
        const { auth, $state } = getServices(transition);
        if (!auth.isAuthenticated()) {
            return $state.target('login', undefined, { location: true });
        }
    };

    transitionService.onBefore({ to: 'start' }, (transition: any) => {
        const { auth, $state } = getServices(transition);
        return goToHomeOrLogin(auth, $state);
    });

    transitionService.onBefore({ to: 'login' }, (transition: any) => {
        const { auth, $state } = getServices(transition);
        if (auth.isAuthenticated()) {
            const selectedModuleHash = localStorage.getItem('selectedModuleHash');
            return $state.target('home', { selectedModuleHash }, { location: true });
        }
    });

    // Register the "requires auth" hook with the TransitionsService
    transitionService.onBefore(requiresAuthCriteria, redirectToLogin, {priority: 10});
}
